module.exports = __webpack_public_path__ + "img/club_unimed.51616174.svg";